import React from "react";
import "./WhyUs.css";
import CheckIcon from "@material-ui/icons/Check";

const WhyUs = () => {
  return (
    <div className="whyUs" id="whyus">
      <div className="whyUs__title">
        <h2>Why Choose us</h2>
        <p>We customise everything we do based on the unique needs of your business.</p>
        <hr />
      </div>

      <div className="whyUs__content">
        <div className="whyUs__content__sec">
          <h2>Klaviyo Masters</h2>
          <div className="whyUs__content__sec__div">
            <div className="whyUs__content__sec__icon">
              <CheckIcon />
            </div>
            <p>
            We know how to get amazing results from Klaviyo and we can ensure you get ROI from your investment.
            </p>
          </div>
        </div>

        <div className="whyUs__content__sec">
          <h2>Grow ROI</h2>
          <div className="whyUs__content__sec__div">
            <div className="whyUs__content__sec__icon">
              <CheckIcon />
            </div>
            <p>
            Everything we do from proposal to implementation is completed with ROI at the forefront.
            </p>
          </div>
        </div>

        <div className="whyUs__content__sec">
          <h2>Grow Revenue From Emails</h2>
          <div className="whyUs__content__sec__div">
            <div className="whyUs__content__sec__icon">
              <CheckIcon />
            </div>
            <p>
            We know it's not enough to simply drive traffic to your site: we'll convert that traffic into revenue.
            </p>
          </div>
        </div>

        {/* <div className="whyUs__content__img">
          <img src={require("../Img/Marke.png")} alt="WhyChooseUs" />
        </div> */}
        <div className="whyUs__content__sec">
          <h2>You Are in Control</h2>
          <div className="whyUs__content__sec__div">
            <div className="whyUs__content__sec__icon">
              <CheckIcon />
            </div>
            <p>
            Enviary empowers you with control over email marketing services by providing you with flexible 
            plans and options tailored for your needs.
            </p>
          </div>
        </div>

        <div className="whyUs__content__sec">
          <h2>Build Profitable Relationships</h2>
          <div className="whyUs__content__sec__div">
            <div className="whyUs__content__sec__icon">
              <CheckIcon />
            </div>
            <p>
            We can help you get more revenue from your existing customers with efficient eCommerce funnels.
            </p>
          </div>
        </div>

        <div className="whyUs__content__sec">
          <h2>Powerful Segmentation</h2>
          <div className="whyUs__content__sec__div">
            <div className="whyUs__content__sec__icon">
              <CheckIcon />
            </div>
            <p>
            We continually optimise the ROI of your email automation through predictive analytics and customer behaviour.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
